module.exports = __webpack_public_path__ + "img/nav-advice@2x.342f940.jpg";